import { TrackingPageModel } from '../tracking-page.model';
import {
  getAsset,
  getFontConfig,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getLanguageMenu,
  white,
  getProductItems
} from './helpers';

export const furniture: TrackingPageModel = {
  languageMenu: getLanguageMenu('Inter', '#000000ff', '700'),
  searchPageInput: {
    backgroundColor: '#ffffff',
    borderColor: '#ced4da',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Josefin Sans', '#d1d1d1ff')
  },
  searchPageTitle: {
    fontSize: 35,
    ...getFontConfig('Inter', '#ffffffff', '700')
  },
  background: {
    color: white,
    useBackgroundImage: true,
    imageUrl: getAsset('/images/themes/furniture.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    backgroundColor: '#ffffff',
    linksColor: '#5780ff',
    linksUnderline: false,
    headerBackground: '#ffffff',
    footerBackground: '#ffffff',
    borderColor: '#d5d9e1',
    borderRadius: 4,
    borderWidth: 1,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Inter', '#000000ff')
  },
  orderCard: {
    backgroundColor: '#ffffff',
    linksColor: '#5780ff',
    linksUnderline: false,
    headerBackground: '#ffffff',
    footerBackground: '#ffffff',
    borderColor: '#d5d9e1',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Ubuntu', '#2E4068')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 16,
    ...getFontConfig('Inter', '#757575ff', '700')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 20,
    ...getFontConfig('Inter', '#222222ff', '700')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Inter', '#cacacaff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 18,
    ...getFontConfig('Inter', '#dc0303ff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    scroll: false,
    itemsLimit: 1,
    borderColor: '#ffb00aff',
    borderWidth: 0,
    borderRadius: 0,
    backgroundColor: '#ffffff',
    shadow: 'none',
    button: {
      on: true,
      backgroundColor: '#212121ff',
      borderColor: '#000000ff',
      borderRadius: 21,
      borderWidth: 0,
      shadow: 'none',
      ...getFontConfig('Inter', '#ffffffff')
    },
    itemCard: {
      backgroundColor: '#ffffff00',
      borderColor: '#2E4068',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 20,
        ...getFontConfig('Josefin Sans', '#000000ff', '700')
      },
      info: {
        alignment: 'left',
        fontSize: 14,
        ...getFontConfig('Josefin Sans', '#909090ff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#ffffffff',
    borderColor: '#2e4068ff',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Inter', '#000000ff', '700')
  },
  detailsButton: {
    backgroundColor: '#2a2a2aff',
    borderColor: '#5780ff',
    borderRadius: 22,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Inter', white)
  },
  trackButton: {
    backgroundColor: '#242424ff',
    borderColor: '#ee7227',
    borderRadius: 22,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Inter', white)
  },
  pageScroll: {
    scrollColor: '#2E4068',
    borderRadius: 2,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(getAsset('/images/themes/furniture-logo.png')),
  socialIcons: getSocialIcons('#484848ff', false),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: '#ffffff',
    borderColor: '#CED2DC',
    borderRadius: 4,
    borderWidth: 1,
    shadow: 'none',
    sidebarField: null,
    ...getFontConfig('Inter', '#000000ff')
  },
  footer: {
    linksColor: '#558686ff',
    linksUnderline: false,
    backgroundColor: '#000000ff',
    ...getFontConfig('Rubik', '#ffffffff'),
    ...getFooterItems()
  },
  header: {
    backgroundColor: '#ffffffff'
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: false,
    backgroundColor: '#ffffff',
    borderColor: '#d5d9e1',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffffff',
      borderColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#292929ff',
        borderColor: '#5780ffff',
        borderRadius: 22,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Ubuntu', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 16,
        ...getFontConfig('Inter', '#000000ff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 12,
        ...getFontConfig('Inter', '#515151ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 18,
        ...getFontConfig('Inter', '#000000ff', '700')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('furniture'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#000000ff',
      arrowSize: 30
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: '#ffffff',
    borderColor: '#d5d9e1',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffffff',
      borderColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#292929ff',
        borderColor: '#5780ffff',
        borderRadius: 22,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Ubuntu', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 16,
        ...getFontConfig('Inter', '#000000ff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 12,
        ...getFontConfig('Inter', '#515151ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 18,
        ...getFontConfig('Inter', '#000000ff', '700')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('furniture'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#000000ff',
      arrowSize: 30
    }
  },
  seoTitle: ''
};
